import React from 'react';
import { goToPage } from '../../../../utils/common';
import { ReceiptStatusEnum, SettleTypeEnum, OrderStatusEnum } from '../../types';
import { getTitleObj } from '../../utils';
import { trackGdp } from '../../../../utils/gio-report';

import './index.less'

interface Props {
  data: {
    applyTime: string,
    estimateFlag: boolean,
    bgnTime: string,
    endTime: string,
    energy: string,
    incomeAmt: string,
    nickName: string,
    orderNo: string,
    orderStatus: OrderStatusEnum,
    receiptStatus: number,
    settleType: string
  }
  userInfo: any
}


const SharingIncomeItem = (props: Props) => {
  const { data, userInfo } = props
  const titleInfo = getTitleObj(data)

  // 个人线上结算 & (订单未完成 || 订单未到账) 展示【预估】
  const displayIncome = data.estimateFlag  ? `¥${data.incomeAmt} 预估` : `¥${data.incomeAmt || '--'}`

  const goToIncomeDetail = () => {
    trackGdp('P20075', 'B043')

    const { origin, pathname } = window.location
    goToPage(`${origin}${pathname}#/order-detail?orderNo=${data.orderNo}&uid=${userInfo?.uid}`)
  }

  return (
    <div className='sharing-income-item-wrap' onClick={goToIncomeDetail}>
      <div className='item'>
        <div className='title-row'>
          <div className='text'>{data.nickName || '--'}</div>
          <div className='text'>{displayIncome}</div>
        </div>
        <div className='energy'>{data.energy ? `充电量：${data.energy}度` : '--'}</div>
        <div className='status-row'>
          <div className='time'>{data?.applyTime || '--'}</div>
          <div className='status' style={{ color: titleInfo?.color }}>{titleInfo?.title || '--'}</div>
        </div>
      </div>
    </div>
  )
}

export default SharingIncomeItem